import React, { useEffect, useState, useContext, useMemo, useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import StoreContext from '../../Store/context';
import SaleNewMobile from '../Mobile/SaleNewMobile';
import {
  Button,
  CircularProgress,
  ClickAwayListener,
  Collapse,
  Fab,
  Grid,
  IconButton,
  InputAdornment,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Popper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { Field, Form, Formik } from 'formik';
import SearchIcon from '@material-ui/icons/Search';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import DeleteIcon from '@material-ui/icons/Delete';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import UIContainer from '../../UI/Container/UIContainer';
import useApi from '../../../utils/useApi';
import UIModalOldForm from '../../UI/ModalOldForm/UIModalOldForm';
import UIFormContainerSale from '../../UI/Form/ContainerSale/UIFormContainerSale';
import SaleSearchItem from '../Modal/searchItem';
import {
  emptyObject,
  formattedCurrency,
  isEqualObject,
  maskedCurrency,
} from '../../../utils/utils';
import { buildSearchItemIndex, searchCatalogFuzzy } from '../../../utils/posFuzzyEngine';
import { resolveScaleBarcodeMatch, parseToledoPriceBarcode, parseLegacyWeightBarcode, calculateScaleItemQuantity } from '../../../utils/scaleBarcodeParser';
import SaleSelect from '../Select/saleSelect';
import UIDialogConfirm from '../../UI/Dialog/Confirm/UIDialogConfirm';
import SaleConfirm from '../Confirm/saleConfirm';
import './saleNew.css';
import useStyles from '../../../utils/useStyle';
import debounce from 'lodash.debounce';

const initialItem = {
  id: '',
  name: '',
  amount: 0,
  valueUn: 0,
  valueTotal: 0,
};

const initialOptions = {
  customer: null,
  plots: 1,
  promotion: null,
  totalGain: 0,
  discount: 0,
  total: 0,
  interest: 0,
  totalSum: 0,
  observation: '',
  paymentData: [],
};

const initialCalculate = {
  onlyCalculate: true,
  customer: null,
  promotion: null,
  setDiscount: null,
  products: {},
  services: {},
  interest: {},
  splitRemaining: 0,
};

const SaleQuantityStepper = ({ amount, onIncrement, onDecrement, onCommit }) => {
  const [localVal, setLocalVal] = useState(String(amount ?? 1));
  const [isLocked, setIsLocked] = useState(false);
  const lockTimerRef = useRef(null);

  useEffect(() => {
    setLocalVal(String(amount ?? 1));
  }, [amount]);

  useEffect(() => {
    return () => {
      if (lockTimerRef.current) clearTimeout(lockTimerRef.current);
    };
  }, []);

  const triggerLock = () => {
    setIsLocked(true);
    if (lockTimerRef.current) clearTimeout(lockTimerRef.current);
    lockTimerRef.current = setTimeout(() => {
      setIsLocked(false);
    }, 350);
  };

  const handleDecClick = () => {
    if (isLocked) return;
    triggerLock();
    onDecrement();
  };

  const handleIncClick = () => {
    if (isLocked) return;
    triggerLock();
    onIncrement();
  };

  const handleBlur = () => {
    const clean = String(localVal).trim().replace(',', '.');
    const num = parseFloat(clean);
    if (!isNaN(num) && num > 0) {
      const rounded = Math.round(num * 1000) / 1000;
      setLocalVal(String(rounded));
      onCommit(rounded);
    } else {
      setLocalVal(String(amount || 1));
      onCommit(amount || 1);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.target.blur();
    }
  };

  const handleChange = (e) => {
    const v = e.target.value;
    if (/^[0-9]*[.,]?[0-9]*$/.test(v) || v === '') {
      setLocalVal(v);
    }
  };

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', backgroundColor: '#f1f5f9', borderRadius: 8, padding: '2px 4px' }}>
      <IconButton
        size="small"
        onClick={handleDecClick}
        disabled={isLocked}
        style={{
          padding: 4,
          backgroundColor: '#ffffff',
          borderRadius: 6,
          boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
          pointerEvents: isLocked ? 'none' : 'auto',
          opacity: isLocked ? 0.6 : 1,
        }}
        title="Diminuir quantidade"
      >
        <RemoveIcon style={{ fontSize: 14, color: '#475569' }} />
      </IconButton>
      <TextField
        type="text"
        size="small"
        value={localVal}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        inputProps={{
          inputMode: 'decimal',
          style: {
            fontSize: 14,
            fontWeight: 700,
            textAlign: 'center',
            width: 46,
            padding: '4px 2px',
            color: '#1e293b',
          },
        }}
        InputProps={{
          disableUnderline: true,
        }}
      />
      <IconButton
        size="small"
        onClick={handleIncClick}
        disabled={isLocked}
        style={{
          padding: 4,
          backgroundColor: '#ffffff',
          borderRadius: 6,
          boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
          pointerEvents: isLocked ? 'none' : 'auto',
          opacity: isLocked ? 0.6 : 1,
        }}
        title="Aumentar quantidade"
      >
        <AddIcon style={{ fontSize: 14, color: '#475569' }} />
      </IconButton>
    </div>
  );
};

const SaleNew = () => {
  const history = useHistory();
  const { credencials, setModalCashierSelect } = useContext(StoreContext);
  const [open, setOpen] = useState(false);
  const { disabledTextField } = useStyles();

  // botôes para foco
  const btnInsert = document.getElementById('btn-new-sale-by-barCode-insert');
  const inputBarCode = document.getElementById('sale-new-search-item');

  // verificar se é mobile e constantes para versão mobile
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [collapse, setCollapse] = useState(false);
  const [collapseAdd, setCollapseAdd] = useState(true);
  const [scroll, setScroll] = useState(1);
  const [qntd, setQntd] = useState(1);

  // valores para o container de salvar e opcoes
  const [cartValues, setCartValues] = useState(initialOptions);
  // array dos produtos na lista
  const [listItens, setListItens] = useState([]);
  // constante para guardar valores para calcular
  const [calculate, setCalculate] = useState(initialCalculate);

  // constante para armazenar input de codigo de barra ou busca por texto
  const [barCode, setBarCode] = useState('');
  const lastItemActionRef = useRef({ time: 0, key: '' });

  // Estados do catálogo em memória (estratégia do modo PDV)
  const [catalogProducts, setCatalogProducts] = useState([]);
  const [catalogServices, setCatalogServices] = useState([]);
  const [catalogCategories, setCatalogCategories] = useState([]);
  const [loadingCatalog, setLoadingCatalog] = useState(false);

  // Estados do Autocomplete Paginado com Infinite Scrolling
  const [autocompleteOpen, setAutocompleteOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const [autocompleteLimit, setAutocompleteLimit] = useState(20);
  const [searchAnchorEl, setSearchAnchorEl] = useState(null);

  // consante para controlar o modal de confirmar venda
  const [modalConfirm, setModalConfirm] = useState(false);
  // Flag para continuar direto para finalização após seleção do caixa
  const [pendingConfirmAfterCashier, setPendingConfirmAfterCashier] = useState(false);

  // modal search item
  const [modalSearch, setModalSearch] = useState(false);

  // select item no modal
  const [item, setItem] = useState(initialItem);

  // controle do alert para sucesso ou falha quando adiciona um item
  // e quando confirma a lista
  const [alertList, setAlertList] = useState(false);

  // ação para click esquerdo
  const [anchorEl, setAnchorEl] = useState(null);
  const [itemChose, setItemChose] = useState(null);

  const handleClickLeft = (event, data) => {
    setItemChose(data);
    setAnchorEl(event.currentTarget);
  };

  const handleCloseClickLeft = () => {
    setItemChose(null);
    setAnchorEl(null);
  };

  const [salesLoad, salesInfo, setSaleInfo] = useApi({
    method: 'post',
    url: '/sales',
  });

  const [searchProductLoad] = useApi({
    debounceDelay: 500,
    method: 'get',
    url: '/products',
  });

  const [searchServicesLoad] = useApi({
    debounceDelay: 500,
    method: 'get',
    url: '/services',
  });

  const [catalogProductsLoad] = useApi({
    method: 'get',
    url: '/products',
  });

  const [catalogServicesLoad] = useApi({
    method: 'get',
    url: '/services',
  });

  const [catalogProdCatLoad] = useApi({
    method: 'get',
    url: '/products/categories',
  });

  const [catalogServCatLoad] = useApi({
    method: 'get',
    url: '/services/categories',
  });

  const [cashierCheckLoad] = useApi({
    method: 'get',
    url: '/cash-registers',
  });

  const lastSyncTimeRef = useRef(Date.now());
  const STALE_CATALOG_THRESHOLD_MS = 3 * 60 * 1000; // 3 minutos de inatividade

  // Carregar catálogo de produtos e serviços em background na entrada da tela
  const loadCatalog = useCallback(async () => {
    if (!credencials?.sessionToken) return;
    setLoadingCatalog(true);
    try {
      const [prodRes, servRes, prodCatRes, servCatRes] = await Promise.all([
        catalogProductsLoad({ params: { lacking: 0 } }),
        catalogServicesLoad({ params: { isActive: 1 } }),
        catalogProdCatLoad({ params: { isActive: 1 } }),
        catalogServCatLoad({ params: { isActive: 1 } }),
      ]);
      setCatalogProducts(prodRes?.data && Array.isArray(prodRes.data) ? prodRes.data : []);
      setCatalogServices(servRes?.data && Array.isArray(servRes.data) ? servRes.data : []);
      const pCats = prodCatRes?.data && Array.isArray(prodCatRes.data) ? prodCatRes.data : [];
      const sCats = servCatRes?.data && Array.isArray(servCatRes.data) ? servCatRes.data : [];
      setCatalogCategories([...pCats, ...sCats]);
      lastSyncTimeRef.current = Date.now();
    } catch (err) {
      console.error('Erro ao carregar catálogo em Nova Venda:', err);
    } finally {
      setLoadingCatalog(false);
    }
  }, [credencials?.sessionToken]);

  useEffect(() => {
    loadCatalog();
  }, [loadCatalog]);

  // Refresh automático ao focar na janela/aba após tempo de inatividade
  useEffect(() => {
    const handleFocusOrVisible = () => {
      if (document.visibilityState === 'visible') {
        const timeSinceLastSync = Date.now() - lastSyncTimeRef.current;
        if (timeSinceLastSync > STALE_CATALOG_THRESHOLD_MS) {
          loadCatalog();
        }
      }
    };

    window.addEventListener('focus', handleFocusOrVisible);
    document.addEventListener('visibilitychange', handleFocusOrVisible);

    return () => {
      window.removeEventListener('focus', handleFocusOrVisible);
      document.removeEventListener('visibilitychange', handleFocusOrVisible);
    };
  }, [loadCatalog]);

  const categoriesMap = useMemo(() => {
    const map = new Map();
    catalogCategories.forEach((cat) => {
      if (cat && cat.id) map.set(String(cat.id), cat.name);
    });
    return map;
  }, [catalogCategories]);

  // Catálogo completo pré-indexado para busca fonética instantânea
  const indexedCatalog = useMemo(() => {
    const list = [
      ...catalogProducts.map((p) => {
        const catId = p.category && typeof p.category === 'object' && p.category.id !== undefined
          ? String(p.category.id)
          : (p.category !== null && p.category !== undefined ? String(p.category) : '');
        const catName = (p.category && typeof p.category === 'object' && p.category.name) || categoriesMap.get(catId) || '';
        return {
          id: p.id,
          name: p.name,
          barCode: p.barCode,
          valueUn: parseFloat(p.value || 0),
          value: parseFloat(p.value || 0),
          typeItem: 'product',
          category: p.category,
          categoryId: catId,
          categoryName: catName,
          amount: parseFloat(p.amount || 0),
        };
      }),
      ...catalogServices.map((s) => {
        const catId = s.category && typeof s.category === 'object' && s.category.id !== undefined
          ? String(s.category.id)
          : (s.category !== null && s.category !== undefined ? String(s.category) : '');
        const catName = (s.category && typeof s.category === 'object' && s.category.name) || categoriesMap.get(catId) || '';
        return {
          id: s.id,
          name: s.name,
          barCode: s.barCode,
          valueUn: parseFloat(s.value || 0),
          value: parseFloat(s.value || 0),
          typeItem: 'service',
          category: s.category,
          categoryId: catId,
          categoryName: catName,
          amount: 999999,
        };
      }),
    ];
    return list.map(buildSearchItemIndex);
  }, [catalogProducts, catalogServices, categoriesMap]);

  // Mapeamento O(1) por código de barras e ID
  const itemsByBarcodeMap = useMemo(() => {
    const map = new Map();
    indexedCatalog.forEach((it) => {
      if (it.barCode) {
        map.set(String(it.barCode).trim().toLowerCase(), it);
      }
      if (it.id) {
        map.set(String(it.id).trim().toLowerCase(), it);
      }
    });
    return map;
  }, [indexedCatalog]);

  // Extração de multiplicador e termo de busca (ex: "3*coca" ou "3*789...")
  const parsedSearch = useMemo(() => {
    const rawVal = String(barCode || '').trim();
    if (!rawVal) return { multiplier: 1, cleanTerm: '' };
    let multiplier = 1;
    let cleanTerm = rawVal;
    if (rawVal.includes('*')) {
      const parts = rawVal.split('*');
      if (parts.length === 2) {
        const parsedM = parseFloat(parts[0].replace(',', '.'));
        if (!isNaN(parsedM) && parsedM > 0) {
          multiplier = parsedM;
          cleanTerm = parts[1].trim();
        }
      }
    }
    return { multiplier, cleanTerm };
  }, [barCode]);

  // Resultados fonéticos instantâneos para o Autocomplete
  const autocompleteResults = useMemo(() => {
    const term = parsedSearch.cleanTerm;
    if (!term) return [];
    if (!indexedCatalog || indexedCatalog.length === 0) return [];
    return searchCatalogFuzzy(term, indexedCatalog, 'all');
  }, [parsedSearch.cleanTerm, indexedCatalog]);

  function changeModal(keepValues) {
    if (keepValues === true) {
      setOpen(false);
      return;
    }
    setOpen(!open);
  }

  function changeViewItens() {
    setCollapse(!collapse);
    setCollapseAdd(false);
  }

  function changeAddItens() {
    setCollapseAdd(!collapseAdd);
    setCollapse(false);
  }

  function changeSearchItens() {
    setModalSearch(!modalSearch);
  }

  function clearFormStorage() {
    localStorage.removeItem('formSaleOptions');
    localStorage.removeItem('formSaleItens');
    localStorage.removeItem('formCalculate');
  }

  function scrollTo(hash) {
    document.location.hash = `#${hash}`;
  }

  useEffect(() => {
    const searchInput = document.getElementById('sale-new-search-item');
    if (searchInput) {
      searchInput.focus();
    }
    const formSaleOptions = JSON.parse(localStorage.getItem('formSaleOptions'));
    const formSaleItens = JSON.parse(localStorage.getItem('formSaleItens'));
    const formCalculate = JSON.parse(localStorage.getItem('formCalculate'));

    if (
      !isEqualObject(formSaleItens || [], []) ||
      !isEqualObject(formSaleOptions || initialOptions, initialOptions)
    ) {
      setCartValues(formSaleOptions);
      setListItens(formSaleItens);
      setCalculate(formCalculate);
      changeModal();
    }
  }, []);

  function handleInputChange(value) {
    setBarCode(value);
    setHighlightedIndex(0);
    setAutocompleteLimit(20);
    if (value && String(value).trim().length > 0) {
      setAutocompleteOpen(true);
    } else {
      setAutocompleteOpen(false);
    }
  }

  function handleDropdownScroll(e) {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - scrollTop - clientHeight < 60) {
      setAutocompleteLimit((prev) => Math.min(autocompleteResults.length, prev + 20));
    }
  }

  function searchBarCode(value = barCode) {
    if (!value || !String(value).trim()) return;

    const rawVal = String(value).trim();
    let code = rawVal;
    let multiplier = 1;

    if (rawVal.includes('*')) {
      const parts = rawVal.split('*');
      if (parts.length === 2) {
        const parsedM = parseFloat(parts[0].replace(',', '.'));
        if (!isNaN(parsedM) && parsedM > 0) {
          multiplier = parsedM;
          code = parts[1].trim();
        }
      }
    }

    const cleanCode = code.toLowerCase();

    // 1. Prioridade Máxima: Código de barras ou ID exato em memória (0ms)
    const exactMatch = itemsByBarcodeMap.get(cleanCode);
    if (exactMatch) {
      const isLacking = exactMatch.typeItem === 'product' && (exactMatch.amount <= 0 || exactMatch.lacking === 1 || exactMatch.lacking === true);
      if (isLacking) return;
      const baseAmount = exactMatch.typeItem === 'product' && parseFloat(exactMatch.amount) < 1 ? parseFloat(exactMatch.amount) : qntd;
      selectItem({
        id: exactMatch.id,
        amountSelected: baseAmount * multiplier,
        name: exactMatch.name,
        value: exactMatch.valueUn || exactMatch.value,
        barCode: exactMatch.barCode,
        typeItem: exactMatch.typeItem,
        category: exactMatch.category,
      });
      setQntd(1);
      setBarCode('');
      setAutocompleteOpen(false);
      return;
    }

    // Detecção modular de código de barras de balança (Toledo Preço Total + Fallback Legado por Peso)
    const findProductInNewSale = (plu, pluStr) => {
      const pStr = String(plu);
      return (
        itemsByBarcodeMap.get(pluStr) ||
        itemsByBarcodeMap.get(pStr) ||
        (indexedCatalog || []).find(
          (p) =>
            String(p.id) === pStr ||
            String(p.id) === pluStr ||
            String(p.barCode) === pluStr ||
            String(p.barCode) === pStr ||
            (p.barCode && p.barCode.endsWith(pluStr))
        )
      );
    };

    const scaleMatch = resolveScaleBarcodeMatch(code, findProductInNewSale);
    if (scaleMatch) {
      const { product: matchedProd, quantity: scaleQty } = scaleMatch;
      const isLacking = matchedProd.typeItem === 'product' && (matchedProd.amount <= 0 || matchedProd.lacking === 1 || matchedProd.lacking === true);
      if (isLacking) return;
      const unitVal = matchedProd.valueUn || matchedProd.value;
      selectItem({
        id: matchedProd.id,
        amountSelected: scaleQty * multiplier,
        name: matchedProd.name,
        value: unitVal,
        barCode: matchedProd.barCode,
        typeItem: matchedProd.typeItem || 'product',
        category: matchedProd.category,
      });
      setQntd(1);
      setBarCode('');
      setAutocompleteOpen(false);
      return;
    }

    // Se o código parece de balança mas não estava em memória, faz busca na API com suporte a fallback
    const scaleFallbackData = parseToledoPriceBarcode(code) || parseLegacyWeightBarcode(code);
    if (scaleFallbackData) {
      const targetPlu = scaleFallbackData.plu || (scaleFallbackData.candidates && scaleFallbackData.candidates[0]?.plu);
      if (targetPlu) {
        searchProductLoad({
          params: { id: targetPlu, lacking: 0 },
          onCompleted: (res) => {
            if (res && res.data && res.data.length > 0) {
              const data = res.data[0];
              const isLacking = data.lacking === true || data.lacking === 1 || data.lacking === '1';
              if (isLacking) return;
              let scaleQty = 1;
              if (scaleFallbackData.mode === 'price') {
                scaleQty = calculateScaleItemQuantity(scaleFallbackData.totalPrice, data.value);
              } else if (scaleFallbackData.candidates && scaleFallbackData.candidates[0]) {
                scaleQty = scaleFallbackData.candidates[0].weight;
              }
              selectItem({
                id: data.id,
                amountSelected: scaleQty * multiplier,
                name: data.name,
                value: data.value,
                barCode: data.barCode,
                typeItem: 'product',
                category: data.category,
              });
              setQntd(1);
              setBarCode('');
              setAutocompleteOpen(false);
            }
          },
        });
        return;
      }
    }

    // 2. Seleção via Autocomplete (item destacado ou primeiro resultado da busca)
    if (autocompleteResults && autocompleteResults.length > 0) {
      const chosen = autocompleteResults[highlightedIndex] || autocompleteResults[0];
      if (chosen) {
        const baseAmount = chosen.typeItem === 'product' && parseFloat(chosen.amount) < 1 ? parseFloat(chosen.amount) : qntd;
        selectItem({
          id: chosen.id,
          amountSelected: baseAmount * multiplier,
          name: chosen.name,
          value: chosen.valueUn || chosen.value,
          barCode: chosen.barCode,
          typeItem: chosen.typeItem,
          category: chosen.category,
        });
        setQntd(1);
        setBarCode('');
        setAutocompleteOpen(false);
        return;
      }
    }

    // 3. Fallback de rede caso o catálogo ainda esteja carregando
    searchProductLoad({
      params: { barCode: code, lacking: 0 },
      onCompleted: (res) => {
        if (res && res.data && res.data.length > 0) {
          const data = res.data[0];
          const isLacking = data.lacking === true || data.lacking === 1 || data.lacking === '1';
          if (isLacking) return;
          const baseAmount = parseFloat(data.amount) < 1 ? parseFloat(data.amount) : qntd;
          selectItem({
            id: data.id,
            amountSelected: baseAmount * multiplier,
            name: data.name,
            value: data.value,
            barCode: data.barCode,
            typeItem: 'product',
            category: data.category,
          });
          setQntd(1);
          setBarCode('');
          setAutocompleteOpen(false);
        }
      },
    });
    searchServicesLoad({
      params: { barCode: code, isActive: 1 },
      onCompleted: (res) => {
        if (res && res.data && res.data.length > 0) {
          const data = res.data[0];
          if (data.isActive === false || data.isActive === 0 || data.isActive === '0') return;
          selectItem({
            id: data.id,
            amountSelected: qntd * multiplier,
            name: data.name,
            value: Number(data.value),
            barCode: data.barCode,
            typeItem: 'service',
            category: data.category,
          });
          setQntd(1);
          setBarCode('');
          setAutocompleteOpen(false);
        }
      },
    });
  }

  function checkCart(list = listItens) {
    const allProducts = list.filter((value) => value.typeItem === 'product');
    const allServices = list.filter((value) => value.typeItem === 'service');

    const products = allProducts.reduce((acc, { id, amount }) => {
      acc[id] = (acc[id] || 0) + Number(amount);
      return acc;
    }, {});
    const services = allServices.reduce((acc, { id, amount }) => {
      acc[id] = (acc[id] || 0) + Number(amount);
      return acc;
    }, {});

    const data = {
      ...calculate,
      products,
      services,
    };
    return emptyObject(data);
  }

  function selectItem(values) {
    const itemToAdd = {
      id: values.id,
      amount: Number(values.amountSelected || 1),
      name: values.name,
      valueUn: Number(values.value || 0),
      valueTotal: Number(values.value || 0) * Number(values.amountSelected || 1),
      typeItem: values.typeItem,
      barCode: values.barCode,
      category: values.category ? (typeof values.category === 'object' ? values.category.id : values.category) : null,
    };
    setItem(itemToAdd);
    setBarCode('');
    addItem(itemToAdd);
  }

  function addItem(values) {
    const itemToAdd = (values && values.name) ? values : item;
    if (itemToAdd && itemToAdd.name) {
      const now = Date.now();
      const itemKey = `add-${itemToAdd.id || itemToAdd.barCode || itemToAdd.name}`;
      if (now - lastItemActionRef.current.time < 250 && lastItemActionRef.current.key === itemKey) {
        return;
      }
      lastItemActionRef.current = { time: now, key: itemKey };

      const testItens = [...listItens, itemToAdd];
      let data = checkCart(testItens);

      const checkDuplicateItem = listItens.find((currentValue, index) => {
        const sameCode = currentValue.barCode && itemToAdd.barCode && currentValue.barCode === itemToAdd.barCode;
        const sameIdAndType = String(currentValue.id) === String(itemToAdd.id) && currentValue.typeItem === itemToAdd.typeItem;
        if (sameCode || sameIdAndType) {
          debouncedEditItem(index, Number(itemToAdd.amount || 1) + Number(listItens[index].amount || 0));
        }
        return sameCode || sameIdAndType;
      });

      if (!checkDuplicateItem) {
        data = checkCart(testItens);
        salesLoad({
          data,
          onCompleted: (res) => {
            if (res) {
              setListItens(testItens);
              setCartValues({ ...cartValues, ...res.data });
              setCalculate({ ...calculate, ...data });
              setItem(initialItem);
              const searchInput = document.getElementById('sale-new-search-item');
              if (searchInput) searchInput.focus();
              if (mobile) {
                changeViewItens();
              }
            } else {
              setAlertList(true);
            }
          },
        });
      }
    }
    setBarCode('');
  }

  function editItem(index, value) {
    if (value >= 0) {
      const now = Date.now();
      const itemKey = `edit-${index}`;
      if (now - lastItemActionRef.current.time < 250 && lastItemActionRef.current.key === itemKey) {
        return;
      }
      lastItemActionRef.current = { time: now, key: itemKey };

      const oldAmount = listItens[index].amount;
      const oldValueTotal = listItens[index].valueTotal;

      listItens[index].amount = value;
      listItens[index].valueTotal =
        Number(value) * Number(listItens[index].valueUn);

      const data = checkCart(listItens);

      salesLoad({
        data: emptyObject(data),
        onCompleted: (res) => {
          if (res) {
            setAlertList(false);
            setListItens(listItens);
            setCalculate({ ...calculate, ...data });
            setCartValues({ ...cartValues, ...res.data });
          } else {
            listItens[index].amount = oldAmount;
            listItens[index].valueTotal = oldValueTotal;
            setListItens(listItens);
            if (value) setAlertList(true);
          }
        },
      });
    }
  }

  const debouncedEditItem = debounce(editItem, 100);

  function removeItem(index) {
    const now = Date.now();
    const itemKey = `remove-${index}`;
    if (now - lastItemActionRef.current.time < 250 && lastItemActionRef.current.key === itemKey) {
      return;
    }
    lastItemActionRef.current = { time: now, key: itemKey };

    const itens = listItens.filter((data, indexData) => indexData !== index);

    const data = checkCart(itens);

    if (itens.length <= 0) {
      setListItens([]);
      setCartValues(initialOptions);
      setCalculate(initialCalculate);
      setAlertList(false);
    } else {
      salesLoad({
        data,
        onCompleted: (res) => {
          if (res) {
            setListItens(itens);
            setCalculate({ ...calculate, ...data });
            setCartValues({ ...cartValues, ...res.data });
          } else {
            setAlertList(true);
          }
        },
      });
    }

    if (mobile) {
      handleCloseClickLeft();
    }
  }

  function selectClient(value) {
    setCartValues({ ...cartValues, customer: value || null });
    setCalculate({ ...calculate, customer: value.id || null });
  }

  function selectPlots(value) {
    if (value >= 0 && value <= 72) {
      setCartValues({ ...cartValues, plots: Number(value) || 1 });
      setCalculate({ ...calculate, plots: Number(value) || 1 });
    }
  }

  function selectPromotion(value) {
    salesLoad({
      data: emptyObject({ ...calculate, promotion: value && value.id }),
      onCompleted: (res) => {
        if (res) {
          setCartValues({ ...cartValues, ...res.data });
          setCalculate({ ...calculate, promotion: value && value.id });
        } else {
          setAlertList(true);
        }
      },
    });
  }

  function setDiscount(value) {
    const discount = Number(value.replace('.', '').replace(',', '.'));
    salesLoad({
      data: emptyObject({ ...calculate, setDiscount: discount }),
      onCompleted: (res) => {
        if (res) {
          setCartValues({ ...cartValues, ...res.data });
          setCalculate({ ...calculate, setDiscount: discount });
        } else {
          setAlertList(true);
          setCartValues({ ...cartValues, setDiscount: null });
        }
      },
    });
  }

  function selectInterest(interest) {
    const value = Number(interest) || 0;
    if (value >= 0 && value <= 100) {
      const objInterest = {
        percentage: value || 0,
        type: 'simples',
      };
      const subtotal = Number(cartValues.totalGain || cartValues.totalSum || 0);
      const discount = Number(cartValues.discount || 0);
      const base = Math.max(0, subtotal - discount);
      const increase = (base * value) / 100;
      const total = base + increase;

      setCartValues((prev) => ({
        ...prev,
        interest: value,
        increase,
        total,
      }));
      setCalculate((prev) => ({
        ...prev,
        interest: objInterest,
      }));
    }
  }

  async function confirmSale() {
    // 1. Se não houver caixa da sessão selecionado, abre o modal de seleção e marca pendência
    if (!credencials?.cashSession || credencials.cashSession === 0 || credencials.cashSession === '0') {
      setPendingConfirmAfterCashier(true);
      if (setModalCashierSelect) setModalCashierSelect(true);
      return;
    }

    setPendingConfirmAfterCashier(false);

    // 2. Verificar se o caixa selecionado está aberto ou fechado
    let isClosed = false;
    await cashierCheckLoad({
      params: { id: credencials.cashSession },
      onCompleted: (res) => {
        if (res && res.data && res.data[0]) {
          const cashier = res.data[0];
          if (
            cashier.isOpen === '0' ||
            cashier.isOpen === 0 ||
            cashier.isOpen === false ||
            !cashier.isOpen
          ) {
            isClosed = true;
          }
        }
      },
    });

    if (isClosed) {
      history.push('/home/caixas/detalhes');
      return;
    }

    // 3. Caixa aberto e válido: prossegue com a confirmação
    salesLoad({
      data: checkCart(listItens),
      onCompleted: (res) => {
        if (res) {
          cartValues.paymentData[0] = {
            amountPaid: maskedCurrency(res.data.total.toFixed(2)),
            paymentMethod: '3',
          };
          setCartValues({
            ...cartValues,
            ...res.data,
            paymentData: cartValues.paymentData,
          });
          setModalConfirm(true);
        } else {
          setAlertList(true);
        }
      },
    });
  }

  // Auto-continua para a finalização assim que o usuário seleciona um caixa
  useEffect(() => {
    if (
      pendingConfirmAfterCashier &&
      credencials?.cashSession &&
      credencials.cashSession !== 0 &&
      credencials.cashSession !== '0'
    ) {
      setPendingConfirmAfterCashier(false);
      confirmSale();
    }
  }, [credencials?.cashSession, pendingConfirmAfterCashier]);

  // reseta o form após concluir venda e atualiza catálogo em background
  function resetform() {
    setCartValues(initialOptions);
    setCalculate(initialCalculate);
    setListItens([]);
    clearFormStorage();
    setModalConfirm(!modalConfirm);
    loadCatalog();
  }

  // limpa o form antigo do local storage
  function clearForm() {
    setCartValues(initialOptions);
    setListItens([]);
    setCalculate(initialCalculate);
    clearFormStorage();
    setOpen(false);
  }

  function nextStateMobile() {
    const confirm = document.getElementById('sale-new-confirm');
    const back = document.querySelector('.sale-new-return');
    if (scroll === 1) {
      confirm.style.visibility = 'visible';
      confirm.style.opacity = 1;
      scrollTo('sale-new-confirm');
    }
    setScroll(scroll + 1);
  }

  function returnStateMobile() {
    const confirm = document.getElementById('sale-new-confirm');
    if (scroll === 2) {
      confirm.style.visibility = 'hidden';
      confirm.style.opacity = 0;
      scrollTo('sale-new-search');
    }
    setScroll(scroll - 1);
  }

  if (
    !isEqualObject(cartValues, initialOptions) ||
    !isEqualObject(listItens, [])
  ) {
    localStorage.setItem('formSaleItens', JSON.stringify(listItens));
    localStorage.setItem('formSaleOptions', JSON.stringify(cartValues));
    localStorage.setItem('formCalculate', JSON.stringify(calculate));
  }

  if (mobile) {
    return (
      <>
        <SaleNewMobile
          listItens={listItens}
          setListItens={setListItens}
          cartValues={cartValues}
          setCartValues={setCartValues}
          calculate={calculate}
          setCalculate={setCalculate}
          selectClient={selectClient}
          selectPromotion={selectPromotion}
          setDiscount={setDiscount}
          selectPlots={selectPlots}
          resetform={resetform}
          searchBarCode={searchBarCode}
          credencials={credencials}
        />
        <UIModalOldForm
          open={open}
          changeModal={changeModal}
          setFormValues={clearForm}
          msgAlert="Há dados no carrinho, deseja continuar a venda?"
          msgContinue="Continuar venda"
          msgNew="Nova venda"
        />
      </>
    );
  }

  return (
    <Grid
      container
      id="sale-new-search"
      style={{ height: mobile ? 'auto' : '100%', scrollBehavior: 'smooth' }}
    >
      <Formik enableReinitialize initialValues={item} onSubmit={addItem}>
        {({ errors, touched, values, setFieldValue }) => (
          <Form style={{ width: '100%' }}>
            <UIContainer container style={{ minHeight: 'auto' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom: 6 }}>
                <span style={{ fontSize: '0.9rem', fontWeight: 600, color: '#17497F' }}>Inserir Itens na Venda</span>
                {!mobile && (
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => {
                      if (!document.fullscreenElement) {
                        document.documentElement.requestFullscreen().catch(() => {});
                      }
                      history.push('/pdv');
                    }}
                    style={{
                      borderColor: '#17497F',
                      color: '#17497F',
                      fontSize: '0.75rem',
                      textTransform: 'none',
                      fontWeight: 700,
                    }}
                  >
                    Modo PDV (Tela Cheia)
                  </Button>
                )}
              </div>
              {mobile && (
                <ListItem button onClick={changeAddItens}>
                  <ListItemIcon>
                    <AddIcon />
                  </ListItemIcon>
                  <ListItemText primary="Adicionar itens" />
                  {collapseAdd ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
              )}
              <Collapse
                in={mobile ? collapseAdd : true}
                timeout="auto"
                unmountOnExit
                style={{ width: '100%' }}
              >
                <Grid container spacing={1}>
                  <Grid item xs={12} md={3}>
                    <ClickAwayListener onClickAway={() => setAutocompleteOpen(false)}>
                      <div ref={(el) => setSearchAnchorEl(el)} style={{ position: 'relative', width: '100%' }}>
                        <TextField
                          id="sale-new-search-item"
                          value={barCode}
                          autoComplete="off"
                          label="Código barras ou Nome (Shift + A)"
                          onChange={(ev) => handleInputChange(ev.target.value)}
                          onFocus={() => {
                            if (barCode && String(barCode).trim().length > 0) {
                              setAutocompleteOpen(true);
                            }
                          }}
                          onKeyDown={(ev) => {
                            if (ev.key === 'ArrowDown') {
                              ev.preventDefault();
                              if (!autocompleteOpen && autocompleteResults.length > 0) {
                                setAutocompleteOpen(true);
                              } else if (autocompleteResults.length > 0) {
                                setHighlightedIndex((prev) => (prev + 1) % autocompleteResults.length);
                              }
                            } else if (ev.key === 'ArrowUp') {
                              ev.preventDefault();
                              if (autocompleteResults.length > 0) {
                                setHighlightedIndex((prev) => (prev - 1 + autocompleteResults.length) % autocompleteResults.length);
                              }
                            } else if (ev.key === 'Escape') {
                              setAutocompleteOpen(false);
                            } else if (ev.key === 'Enter') {
                              ev.preventDefault();
                              ev.stopPropagation();
                              if (barCode) {
                                searchBarCode(barCode);
                              }
                            }
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  title="Atalho: Shift + Espaço"
                                  onClick={changeSearchItens}
                                >
                                  <SearchIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          fullWidth
                        />

                        <Popper
                          open={autocompleteOpen && autocompleteResults.length > 0}
                          anchorEl={searchAnchorEl}
                          placement="bottom-start"
                          style={{ zIndex: 1300, width: searchAnchorEl ? Math.max(searchAnchorEl.clientWidth, 380) : 380 }}
                        >
                          <Paper
                            elevation={6}
                            onScroll={handleDropdownScroll}
                            style={{
                              maxHeight: 280,
                              overflowY: 'auto',
                              marginTop: 4,
                              borderRadius: 6,
                              border: '1px solid #cbd5e1',
                              backgroundColor: '#ffffff',
                            }}
                          >
                            {autocompleteResults.slice(0, autocompleteLimit).map((resultItem, idx) => {
                              const isHighlighted = idx === highlightedIndex;
                              return (
                                <div
                                  key={`${resultItem.typeItem}-${resultItem.id}`}
                                  onMouseEnter={() => setHighlightedIndex(idx)}
                                  onClick={() => {
                                    const baseAmount = resultItem.typeItem === 'product' && parseFloat(resultItem.amount) < 1 ? parseFloat(resultItem.amount) : qntd;
                                    selectItem({
                                      id: resultItem.id,
                                      amountSelected: baseAmount * parsedSearch.multiplier,
                                      name: resultItem.name,
                                      value: resultItem.valueUn || resultItem.value,
                                      barCode: resultItem.barCode,
                                      typeItem: resultItem.typeItem,
                                      category: resultItem.category,
                                    });
                                    setQntd(1);
                                    setBarCode('');
                                    setAutocompleteOpen(false);
                                  }}
                                  style={{
                                    padding: '8px 12px',
                                    cursor: 'pointer',
                                    backgroundColor: isHighlighted ? '#e2e8f0' : 'transparent',
                                    borderBottom: '1px solid #f1f5f9',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 2,
                                  }}
                                >
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ fontWeight: 600, fontSize: '0.88rem', color: '#0f172a' }}>
                                      {resultItem.name}
                                    </span>
                                    <span style={{ fontWeight: 700, fontSize: '0.88rem', color: '#166534' }}>
                                      {formattedCurrency(resultItem.valueUn || resultItem.value || 0)}
                                    </span>
                                  </div>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '0.75rem', color: '#64748b' }}>
                                    <span>
                                      {resultItem.typeItem === 'product' ? 'Produto' : 'Serviço'}
                                      {resultItem.barCode ? ` • Cód: ${resultItem.barCode}` : ''}
                                    </span>
                                    <span>
                                      {resultItem.typeItem === 'product'
                                        ? `Estoque: ${resultItem.amount !== undefined ? resultItem.amount : '-'}`
                                        : 'Disponível'}
                                    </span>
                                  </div>
                                </div>
                              );
                            })}
                            {autocompleteResults.length > autocompleteLimit && (
                              <div style={{ textAlign: 'center', padding: '6px', fontSize: '0.75rem', color: '#94a3b8' }}>
                                Role para ver mais...
                              </div>
                            )}
                          </Paper>
                        </Popper>
                      </div>
                    </ClickAwayListener>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Field
                      name="name"
                      label="Item"
                      placeholder="Nome do item"
                      fullWidth
                      className={disabledTextField}
                      disabled
                      as={TextField}
                    />
                  </Grid>
                  <Grid item xs={12} md={1}>
                    <TextField
                      id="sale-new-select-amount-on-barcode"
                      value={qntd}
                      onChange={(ev) => {
                        if (ev.target.value >= 0) {
                          setQntd(Number(ev.target.value));
                          setFieldValue(
                            'valueTotal',
                            values.valueUn * Number(ev.target.value),
                          );
                        }
                      }}
                      label="Qntd."
                      type="number"
                      error={Boolean(errors.amount)}
                      helperText="Setas ⬆ ⬇"
                      placeholder="Insira a quantidade"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <CurrencyTextField
                      type="tel"
                      value={values.valueUn}
                      label="Valor unitario"
                      decimalCharacter=","
                      digitGroupSeparator="."
                      currencySymbol="R$"
                      outputFormat="string"
                      fullWidth
                      className={disabledTextField}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <CurrencyTextField
                      type="tel"
                      value={values.valueTotal}
                      label="Valor total"
                      decimalCharacter=","
                      digitGroupSeparator="."
                      currencySymbol="R$"
                      outputFormat="string"
                      fullWidth
                      className={disabledTextField}
                      disabled
                    />
                  </Grid>
                  <Grid
                    container
                    item
                    justify={mobile ? 'flex-end' : 'center'}
                    alignItems={mobile ? 'flex-end' : 'center'}
                    xs={12}
                    md={1}
                  >
                    <Button
                      id="btn-new-sale-by-barCode-insert"
                      variant="contained"
                      type="submit"
                      onClick={(e) => {
                        if (barCode) {
                          e.preventDefault();
                          searchBarCode(barCode);
                        }
                      }}
                      className="sale-new__insert-button"
                      startIcon={
                        (searchProductLoad.loading && (
                          <CircularProgress size="0.9rem" color="inherit" />
                        )) ||
                        (searchServicesLoad.loading && (
                          <CircularProgress size="0.9rem" color="inherit" />
                        ))
                      }
                    >
                      Inserir
                    </Button>
                  </Grid>
                </Grid>
              </Collapse>
            </UIContainer>
          </Form>
        )}
      </Formik>

      <SaleSearchItem
        open={modalSearch}
        mobile={mobile}
        handleModal={changeSearchItens}
        selectItem={selectItem}
        listItems={calculate}
        btnInsert={btnInsert}
        catalog={indexedCatalog}
        categories={catalogCategories}
        loadingCatalog={loadingCatalog}
      />

      <Grid
        item
        container
        justify="space-between"
        xs={12}
        style={{
          height: mobile ? 'auto' : '65%',
          paddingBottom: '15px',
        }}
      >
        <UIContainer
          container
          item
          style={{
            width: mobile ? '100%' : '70%',
            height: mobile ? 'auto' : '100%',
            overflow: 'auto',
          }}
        >
          {!mobile ? (
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Qntd.</TableCell>
                    <TableCell>Produto</TableCell>
                    <TableCell>Valor un</TableCell>
                    <TableCell>Valor total</TableCell>
                    <TableCell>Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listItens !== [] &&
                    listItens &&
                    listItens.map((data, index) => {
                      const calcList = data.typeItem === 'product' ? cartValues.products : cartValues.services;
                      const calcItem = Array.isArray(calcList)
                        ? calcList.find((it) => String(it.id) === String(data.id))
                        : null;
                      const hasDiscount = calcItem && Number(calcItem.discount) > 0;

                      return (
                        <TableRow key={data.id} hover>
                          <TableCell width="20%">
                            <SaleQuantityStepper
                              amount={data.amount}
                              onIncrement={() => {
                                const currentAmt = Number(data.amount || 0);
                                debouncedEditItem(index, Math.round((currentAmt + 1) * 1000) / 1000);
                              }}
                              onDecrement={() => {
                                const currentAmt = Number(data.amount || 1);
                                if (currentAmt > 1) {
                                  debouncedEditItem(index, Math.round((currentAmt - 1) * 1000) / 1000);
                                } else {
                                  removeItem(index);
                                }
                              }}
                              onCommit={(newQty) => {
                                debouncedEditItem(index, newQty);
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 6 }}>
                              <span>{data.name}</span>
                              {hasDiscount && (
                                <span
                                  style={{
                                    fontSize: '0.72rem',
                                    backgroundColor: '#E8F5E9',
                                    color: '#2E7D32',
                                    padding: '2px 6px',
                                    borderRadius: 4,
                                    fontWeight: 600,
                                  }}
                                >
                                  -{formattedCurrency(calcItem.discount)}
                                </span>
                              )}
                            </div>
                          </TableCell>
                          <TableCell>{formattedCurrency(data.valueUn)}</TableCell>
                          <TableCell>
                            {hasDiscount ? (
                              <div>
                                <span
                                  style={{
                                    textDecoration: 'line-through',
                                    color: '#9E9E9E',
                                    fontSize: '0.8rem',
                                    marginRight: 6,
                                  }}
                                >
                                  {formattedCurrency(data.valueTotal)}
                                </span>
                                <span style={{ fontWeight: 700, color: '#1B5E20' }}>
                                  {formattedCurrency(calcItem.total)}
                                </span>
                              </div>
                            ) : (
                              formattedCurrency(data.valueTotal)
                            )}
                          </TableCell>
                          <TableCell>
                            <span title="Excluir item">
                              <IconButton onClick={() => removeItem(index)}>
                                <DeleteIcon />
                              </IconButton>
                            </span>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <>
              <ListItem button onClick={changeViewItens}>
                <ListItemIcon>
                  <AddIcon />
                </ListItemIcon>
                <ListItemText primary="Ver itens" />
                {collapse ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse
                in={collapse}
                timeout="auto"
                unmountOnExit
                style={{ overflow: 'auto', width: '100%' }}
              >
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Qntd.</TableCell>
                        <TableCell>Produto</TableCell>
                        <TableCell>Valor un</TableCell>
                        <TableCell>Valor total</TableCell>
                        <TableCell>Ações</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {listItens !== [] &&
                        listItens &&
                        listItens.map((data, index) => {
                          const calcList = data.typeItem === 'product' ? cartValues.products : cartValues.services;
                          const calcItem = Array.isArray(calcList)
                            ? calcList.find((it) => String(it.id) === String(data.id))
                            : null;
                          const hasDiscount = calcItem && Number(calcItem.discount) > 0;

                          return (
                            <TableRow key={data.id} hover>
                              <TableCell component="th" scope="row">
                                <TextField
                                  value={data.amount}
                                  onChange={(ev) => {
                                    const val = ev.target.value;
                                    setListItens((prev) => prev.map((item, idx) => {
                                      if (idx === index) {
                                        return {
                                          ...item,
                                          amount: val,
                                          valueTotal: Number(val) * Number(item.valueUn)
                                        };
                                      }
                                      return item;
                                    }));
                                  }}
                                  onBlur={(ev) => {
                                    if (!ev.target.value || ev.target.value === '0') {
                                      debouncedEditItem(index, 1);
                                    } else {
                                      debouncedEditItem(index, ev.target.value);
                                    }
                                  }}
                                  type="number"
                                />
                              </TableCell>
                              <TableCell
                                onClick={(ev) => handleClickLeft(ev, index)}
                              >
                                <div>
                                  <span>{data.name}</span>
                                  {hasDiscount && (
                                    <div style={{ marginTop: 2 }}>
                                      <span
                                        style={{
                                          fontSize: '0.7rem',
                                          backgroundColor: '#E8F5E9',
                                          color: '#2E7D32',
                                          padding: '1px 5px',
                                          borderRadius: 4,
                                          fontWeight: 600,
                                        }}
                                      >
                                        -{formattedCurrency(calcItem.discount)}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </TableCell>
                              <TableCell
                                onClick={(ev) => handleClickLeft(ev, index)}
                              >
                                {formattedCurrency(data.valueUn)}
                              </TableCell>
                              <TableCell
                                onClick={(ev) => handleClickLeft(ev, index)}
                              >
                                {hasDiscount ? (
                                  <div>
                                    <span
                                      style={{
                                        textDecoration: 'line-through',
                                        color: '#9E9E9E',
                                        fontSize: '0.78rem',
                                        marginRight: 4,
                                      }}
                                    >
                                      {formattedCurrency(data.valueTotal)}
                                    </span>
                                    <span style={{ fontWeight: 700, color: '#1B5E20' }}>
                                      {formattedCurrency(calcItem.total)}
                                    </span>
                                  </div>
                                ) : (
                                  formattedCurrency(data.valueTotal)
                                )}
                              </TableCell>
                              <TableCell>
                                <span title="Excluir item">
                                  <IconButton onClick={() => removeItem(index)}>
                                    <DeleteIcon />
                                  </IconButton>
                                </span>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Collapse>
            </>
          )}
        </UIContainer>
        <UIContainer
          id="sale-new-select"
          container
          item
          style={{
            width: mobile ? '100%' : '29%',
            height: mobile ? 'auto' : '100%',
            overflow: 'auto',
          }}
        >
          <SaleSelect
            options={cartValues}
            listItens={listItens}
            setOptions={setCartValues}
            selectPlots={selectPlots}
            selectClient={selectClient}
            selectPromotion={selectPromotion}
            setDiscount={setDiscount}
            selectInterest={selectInterest}
            changeSearchItens={changeSearchItens}
            confirmSale={confirmSale}
            inputBarCode={inputBarCode}
            qntd={qntd}
            setQntd={setQntd}
          />
        </UIContainer>
      </Grid>

      <UIFormContainerSale
        id="sale-new-confirm"
        mobile={mobile}
        style={{ minHeight: mobile ? 'auto' : '20%' }}
        onConfirmed={confirmSale}
        sale={salesInfo}
        data={cartValues}
      />

      <SaleConfirm
        open={modalConfirm}
        options={cartValues}
        calculate={calculate}
        setOptions={setCartValues}
        handleModal={() => setModalConfirm(!modalConfirm)}
        resetform={resetform}
        mobile={mobile}
      />

      <UIDialogConfirm
        open={alertList}
        data={salesInfo}
        timeSucess={3000}
        messageSucess="Ação feita com sucesso!"
        close={() => setAlertList(!alertList)}
        setrequestinfo={setSaleInfo}
      />

      <UIModalOldForm
        open={open}
        changeModal={changeModal}
        setFormValues={clearForm}
        msgAlert="Há dados no carrinho, deseja continuar a venda?"
        msgContinue="Continuar venda"
        msgNew="Nova venda"
      />

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseClickLeft}
      >
        <MenuItem onClick={() => removeItem(itemChose)}>
          Exluir produto
        </MenuItem>
      </Menu>

      {mobile && scroll !== 2 && (
        <Tooltip className="sale-new-next" title="Avançar">
          <Fab
            style={{ backgroundColor: '#178208', color: '#fff' }}
            size="small"
            variant="extended"
            onClick={nextStateMobile}
          >
            <ArrowDownwardIcon />
            Avançar
          </Fab>
        </Tooltip>
      )}
      {mobile && scroll > 1 && scroll < 3 && (
        <Tooltip className="sale-new-return" title="Voltar">
          <Fab
            style={{ backgroundColor: '#C40409', color: '#fff' }}
            size="small"
            variant="extended"
            onClick={returnStateMobile}
          >
            <ArrowUpwardIcon />
            Voltar
          </Fab>
        </Tooltip>
      )}
    </Grid>
  );
};

export default SaleNew;
